import type { ReapproCategoryAlgorithmUpdate } from '@gozoki/api-types'
import type { CategoryForm } from '../forms/useCategoryForm'
import type { InternalCategoryForm } from '../forms/useInternalCategoryForm'
import type { ReapproCategoryForm } from '../forms/useReapproCategoryForm'
import { gozokiApiWithAuth } from '../gozokiApi'

// Categories

export const createCategory = async (data: CategoryForm) => {
  const response = await gozokiApiWithAuth.post('/categories', data, {
    headers: {
      // This request contains a file
      'Content-Type': 'multipart/form-data',
    },
  })
  return response
}

export const destroyCategory = async (id: number) => {
  const response = await gozokiApiWithAuth.delete(`/categories/${id}`)
  return response
}

export const destroyCategories = async (ids: number[]) => {
  const responses = await Promise.all(ids.map((id) => destroyCategory(id)))
  return responses
}

export const updateCategory = async ({ id, data }: UpdateCategoryArgs) => {
  const response = await gozokiApiWithAuth.patch(`/categories/${id}`, data, {
    headers: {
      // This request contains a file
      'Content-Type': 'multipart/form-data',
    },
  })
  return response
}

interface UpdateCategoryArgs {
  id: number
  data: Partial<CategoryForm>
}

// Internal categories

export const createInternalCategory = async (data: InternalCategoryForm) => {
  const response = await gozokiApiWithAuth.post('/internal-categories', data)
  return response
}

export const updateInternalCategory = async (id: number, data: InternalCategoryForm) => {
  const response = await gozokiApiWithAuth.patch(`/internal-categories/${id}`, data)
  return response
}

export const deleteInternalCategory = async (ids: number[]) => {
  const response = await Promise.all(
    ids.map((id) => gozokiApiWithAuth.delete(`/internal-categories/${id}`)),
  )
  return response
}

// Reappro categories

export const createReapproCategory = async (data: ReapproCategoryForm) => {
  const response = await gozokiApiWithAuth.post('/reappro-categories', data)
  return response
}

export const updateReapproCategory = async (id: number, data: ReapproCategoryForm) => {
  const response = await gozokiApiWithAuth.patch(`/reappro-categories/${id}`, data)
  return response
}

export const deleteReapproCategory = async (ids: number[]) => {
  const response = await Promise.all(
    ids.map((id) => gozokiApiWithAuth.delete(`/reappro-categories/${id}`)),
  )
  return response
}

export const updateReapproCategoryAlgorithms = async (
  algorithms: ReapproCategoryAlgorithmUpdate[],
) => {
  const response = await gozokiApiWithAuth.put('/reappro-categories/algorithms', { algorithms })
  return response
}
